import React, { useState, useEffect, useContext } from 'react'
import { Card, Select, Row, Col, Popconfirm, Typography, Badge, Button, Radio, Modal, Tabs, notification, TimePicker, Space, Form, Collapse, Spin } from 'antd';
import moment from 'moment';
import _ from "lodash"
import { BlankSpace, PageContainer } from "../../component/Xcomponent";
import { connect } from "react-redux";
//Actions
import { CaretRightOutlined } from '@ant-design/icons';

import { getQuickSupport } from '../../action/getQuickSupport';
import HeaderContext from '../../context/HeaderContext';
import "./QuickSupport.css";

const { Panel } = Collapse;

const QuickSupport = props => {
	const {
		getQuickSupport, getQuickSupportState
	} = props;
	const [quickSupportData, setQuickSupportData] = useState([]);
	const [dataFound, setDataFound] = useState();
	const {setTitle} = useContext(HeaderContext);
  	setTitle("Quick Support");
	
	const onChange = (key) => {
		console.log(key);
	};

	useEffect(() => {
		getQuickSupport({})
		//let data = true;
		//(async () => {
		//	await data
		//})()
	}, [])

	useEffect(() => {
		if (getQuickSupportState.apiState === "success") {
			console.log("getQuickSupportState", getQuickSupportState)
			setQuickSupportData(getQuickSupportState.result);
		}
	}, [getQuickSupportState])

	const QuickSupportParent = () => {
		return <>
		<Collapse style={{background:"transparent"}} bordered={false} onChange={onChange} accordion expandIcon={({ isActive }) => <CaretRightOutlined rotate={isActive ? 90 : 0} />} >
			{ quickSupportData.map((category, id1) => 
				<Panel
					style={{
						background: "#fff",
						boxShadow: "0px 4px 10px rgb(0 0 0 / 3%)",
						borderRadius: "15px",
						marginBottom: "15px",
						border: "none",
					}}
					header={
						<>
						<div className='d-flex align-items-center'>
							<h6 className='mb-0' style={{fontSize:"19px",fontWeight:"500"}}>
							{category.name}
							</h6>
						</div>
						</>
					  }
					>{
						QuickSupportChild(category)
					}
				</Panel>
				)
			}
		</Collapse>
		</>
	}

	const QuickSupportChild = (category) => {
		return <>
			{category.children.length > 0 &&
				category.children.map((child_category, id2) =>
				<>
					<Collapse key={id2} style={{background:"transparent"}} bordered={false} onChange={onChange} accordion expandIcon={({ isActive }) => <CaretRightOutlined rotate={isActive ? 90 : 0} />}>
						<Panel
							style={{
								background: "#fff",
								boxShadow: "rgba(0, 0, 0, 0.04) 0px 0px 8px 4px",
								borderRadius: "15px",
								marginBottom: "15px",
								// border: "none",
							}}
							header={
								<>
								<div className='d-flex align-items-center'>
									<h6 className='mb-0' style={{fontSize:"16px",fontWeight:"500"}}>
									{child_category.name}
									</h6>
								</div>
								</>
							  }
							
						>
							{QuickSupportChild(child_category)}
						</Panel>
					</Collapse>
				</>
				)
			}
			{/* <br></br> */}
			{/* {category.quick_support_question_answer.map((questionAnswers) =>
				<>
					<div>
						<h6>{questionAnswers.question}</h6>
						<p className='supportText' style={{fontSize:"small"}} dangerouslySetInnerHTML={{ __html: decodeURIComponent(questionAnswers.answer) }} />
					</div>
				</>
			)} */}
			{category.quick_support_question_answer.map((questionAnswers, id3) => (
          <Collapse key={id3} style={{ background: 'transparent' }} bordered={false} accordion expandIcon={({ isActive }) => <CaretRightOutlined rotate={isActive ? 90 : 0} />}>
            <Panel
              header={
				<>
				<div className='d-flex align-items-center'>
					<h6 className='mb-0' style={{fontSize:"14px", fontWeight:"500"}}>
					{questionAnswers.question}
					</h6>
				</div>
				</>
			  }
              style={{
                background: '#fff',
                boxShadow: "rgba(0, 0, 0, 0.04) 0px 0px 8px 4px",
                borderRadius: '15px',
                marginBottom: '15px',
                border: 'none',
              }}
            >
              <p className='supportText' style={{ fontSize: 'small' }} dangerouslySetInnerHTML={{ __html: decodeURIComponent(questionAnswers.answer) }} />
            </Panel>
          </Collapse>
        ))}
		</>
	}
	
	return (
		<div>
			<PageContainer>
				{getQuickSupportState.apiState == "loading" &&
					<div style={{ textAlign: "center", marginTop:"100px" }}>
						<Spin size="large" tip="Loading Quick Support..."/>
					</div>
				}
				{getQuickSupportState.apiState === "success" &&
					<div style={{ width: '100%', justifyContent: "flex-start" }}>
						{/* <h4>Quick Support</h4> */}
						<QuickSupportParent></QuickSupportParent>
					</div>
				}
			</PageContainer>
		</div>
	)
};

const mapStateToProps = (state) => ({
	getQuickSupportState: state.getQuickSupport,

});

const mapDispatchToProps = (dispatch) => ({
	getQuickSupport: (params) => dispatch(getQuickSupport(params)),

});

export default connect(mapStateToProps, mapDispatchToProps)(QuickSupport);
